import Vue from "vue";
import Vuex from "vuex";
Vue.use(Vuex);
// import createPersistedState from "vuex-persistedstate";
import { getInit, changeInit } from "@/utils";
import { state } from "@/store/state.js";
export default new Vuex.Store({
    state,
    mutations: changeInit(),
    getters: getInit(),
    // strict: process.env.NODE_ENV !== "production",
    // plugins: [
    //     createPersistedState({
    //         storage: window.sessionStorage,
    //     }),
    // ],
});
